import { gql } from "@apollo/client";

const UPDATE_GALLERY = gql`
  mutation updateAlbum(
    $id: Int!
    $title: String
    $thumbnail: Upload
    $isSpecificTournament: Boolean
    $isAlbumPublic: Boolean
    $albumCustomEvent: String
    $albumTags: String
    $date: String
    $platform: Int
    $league: Int
    $tournament: Int
    $federation: Int
    $club: Int
  ) {
    updateAlbum(
      updateAlbumInput: {
        id: $id
        title: $title
        thumbnail: $thumbnail
        isSpecificTournament: $isSpecificTournament
        isAlbumPublic: $isAlbumPublic
        albumCustomEvent: $albumCustomEvent
        albumTags: $albumTags
        date: $date
        platform: $platform
        league: $league
        tournament: $tournament
        federation: $federation
        club: $club
      }
    ) {
      id
    }
  }
`;

export default UPDATE_GALLERY;
